var collapsible_list_component_rtlignore_default = {
  "ltr": "q81lZ",
  "rtl": "a-O-E",
  "iconContainer": "TPHym",
  "icon": "_2h2Zr",
  "isExpanded": "Ai0aV",
  "listDimensions": "cbQfO"
};
export {
  collapsible_list_component_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-component.rtlignore-scss.js.map
